import { Component, OnInit } from '@angular/core';
import { Offerte } from '../model/offerte';
import { OfferteServiceService } from '../service/offerte-service.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
 
constructor(private service: OfferteServiceService) 
{ 
   
   
}

  ngOnInit() {
  }

}
 


// WEBPACK FOOTER //
// ./src/app/faqs/faq.component.ts